import { createApp } from 'vue';
import CalculatorPointsMiles from './components/CalculatorPointsMiles.vue';
import MilesAndMoreLevelSelector from './components/MilesAndMoreLevelSelector.vue';
import QualifyingBenefits from './components/emirates/QualifyingBenefits.vue';
import EmiratesCalculator from './components/emirates/EmiratesCalculator.vue';
import EmiratesBenefitsModal from './components/emirates/EmiratesBenefitsModal.vue';
import AlterraAwardCodeForm from './components/alterra/AwardCodeForm.vue';
import japanAirlinesBenefitsSwitcher from './components/japan-airlines/BenefitsSwitcher.vue';

createApp({
  components: {
    CalculatorPointsMiles,
    MilesAndMoreLevelSelector,
    QualifyingBenefits,
    EmiratesCalculator,
    EmiratesBenefitsModal,
    AlterraAwardCodeForm,
    japanAirlinesBenefitsSwitcher,
  }
}).mount('#app');

// -------------
// Init jquery, popper.js, & Bootstrap
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) { console.log(e); }

// -------------
// Init Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
